export const SidebarSvg = () => (
    <svg width="100%" height="100%" viewBox="0 0 197 155" fill="none" xmlns="http://www.w3.org/2000/svg"
         preserveAspectRatio="xMidYMid meet" focusable="false">
        <rect x="0.5" y="0.5" width="196" height="154" fill="#F9F9F9" stroke="#BDC1C6"></rect>
        <rect x="130.5" y="0.5" width="66" height="154" fill="white" stroke="#BDC1C6"></rect>
        <rect x="130.5" y="0.5" width="66" height="13" fill="#4285F4" stroke="#BDC1C6"></rect>
        <rect x="134" y="119" width="37" height="10" rx="2" fill="#D3E3FD"></rect>
        <rect x="134" y="77" width="47" height="18" rx="2" fill="#D3E3FD"></rect>
        <rect x="151" y="99" width="41" height="17" rx="2" fill="#DADCE0"></rect>
        <rect x="130.5" y="133.5" width="66" height="21" fill="white" stroke="#BDC1C6"></rect>
        <rect x="134.5" y="138.5" width="58" height="11" rx="5.5" fill="#F1F3F4" stroke="#BDC1C6"></rect>
        <g opacity="0.8"
            clip-path="url(#clip0_1607_177367')">
            <path
                d="M182.5 147V141L190 144L182.5 147ZM183.25 145.885L187.979 144L183.25 142.115V143.25L185.5 144L183.25 144.75V145.885ZM183.25 145.885V144V142.115V143.25V144.75V145.885Z"
                fill="#444746"></path>
        </g>
        <defs>
            <clipPath id="clip0_1607_177367">
                <rect width="12" height="11" fill="white" transform="translate(180 138)"></rect>
            </clipPath>
        </defs>
    </svg>
);